// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { Chapter as ChapterType } from '../../../../../types/Model';
import Chapter from './Chapter';

interface ChapterTabProps {
  chapters: ChapterType[];
  courseId: number;
}

const ChapterTab: React.FC<ChapterTabProps> = (props):JSX.Element => {
  const {
    courseId,
    chapters,
  } = props;

  return (
    <>
      {
        chapters.map((chapter:ChapterType, index) => (
          <Chapter
            key={index}
            courseId={courseId}
            chapters={chapters}
            chapterIndex={index}
          />
        ))
      }
    </>
  );
}

export { ChapterTab as default };
